// extracted by mini-css-extract-plugin
export default {"content":"Page404_content__t19qN","error_code":"Page404_error_code__gIdOX","link":"Page404_link__tDgAv"};